export default {
  state: () => ({
    modals: {
      auth: {
        value: false,
        props: {
          tab: 'login',
        },
      },
      sportModalStatus: false,
      customModal: null,
    },
  }),
  mutations: {
    PUSH_MODAL(state, payload) {
      state.modals.customModal = payload
    },
    SET_SPORT_MODAL_STATUS(state, payload) {
      state.modals.sportModalStatus = payload
    },
  },
  getters: {
    getSportModalStatus: (s) => s.modals.sportModalStatus,
    modals: (s) => s.modals,
    getCustomModal: (s) => s.modals.customModal,
  },
}
